import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=5abdaaa8&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=ts"
export * from "./AfterSales.vue?vue&type=script&lang=ts"
import style0 from "./AfterSales.vue?vue&type=style&index=0&id=5abdaaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abdaaa8",
  null
  
)

export default component.exports